import React from 'react'
import NewsFeedItemContainer from './StyledNewsFeedItemContainer'
import NewsFeedLink from './StyledNewsFeedLink'
import NewsFeedImage from './StyledNewsFeedImage'
import NewsFeedTitle from './StyledNewsFeedTitle'

const NewsFeedItem = (props) => {
  const {
    guid,
    link,
    title,
    image,
    children,
    handleAnchorClick = () => {}
  } = props

  return (
    <NewsFeedItemContainer key={guid}>
      <NewsFeedLink
        href={link}
        onClick={event => {
          handleAnchorClick(event, link)
        }}
      >
        <NewsFeedImage src={image} alt={title}/>
        <NewsFeedTitle>
          {title}
        </NewsFeedTitle>
        {
          children
        }
      </NewsFeedLink>
    </NewsFeedItemContainer>
  )
}

export default NewsFeedItem
